import debounce from 'lodash.debounce'
export var positionHeader = function() {
	//selectores
	var $heightJS = $('#height_JS')
	var $header = $('#header-fixed_JS')
	var menu = $('#responsive-fixed_JS');

	//booleanos o logica
	var isFixed = false
	
	//acciones
	var onScroll = () => {
		var altura = $heightJS.height();
		var isOverMd = $(window).width() >= 993
		var shouldBeFixed = $(window).scrollTop() >= altura

		if (!isOverMd) { return }

		if (shouldBeFixed && !isFixed) {			
			$header.show();
			$header.css('visibility', 'visible');
			$heightJS.css('visibility','hidden');
			isFixed = true
		}
		if (!shouldBeFixed && isFixed) {
			$header.hide();
			$header.css('visibility','hidden');
			$heightJS.css('visibility','visible');
			isFixed = false
		}
	}
	
	//handlers
	$(window).scroll(onScroll);
	$(window).resize(onScroll);
}


